import { Image } from "@chakra-ui/react";

const RightOutlined = () => {
  return(
    <Image
      maxW="20px"
      src="/images/icons/RightOutlined.svg"
      transition="filter .2s"
    />
  )
}

export { RightOutlined }